import { GridAggregationFunction } from '@mui/x-data-grid-premium';

export const LEG: GridAggregationFunction<
  { membershipLength: { value: number; name: string }; ownerId: number },
  number
> = {
  label: 'LEG',
  getCellValue: ({ row }) => ({ membershipLength: row.membershipLength, ownerId: row.ownerId }),
  apply: ({ values }) => {
    if (values === null) {
      return null;
    }
    let membershipLengthSum = 0;
    const members: number[] = [];
    values.forEach((x) => {
      if (x && x.membershipLength) {
        membershipLengthSum += Number(x.membershipLength.value);
        members.push(x.ownerId);
      }
    });
    return Number((membershipLengthSum / members.filter((x) => x).length).toFixed(2));
  },
  columnTypes: ['number'],
};
